import { useTranslation } from 'react-i18next';
import { BookingsDecisions } from 'src/features/spaces/api/types/payload/delete-space.payload';
import { z } from 'zod';

export const useDeleteSpaceDialogFormValidationSchema = (
  bookingsAmount: number,
) => {
  const { t } = useTranslation(['spaces', 'validation']);

  const bookingsDecisionsSchema: z.ZodType<BookingsDecisions> = z.object({
    moveBookingDecisions: z.array(
      z.object({
        bookingToken: z.string(),
        spaceToken: z.string(),
      }),
    ),
    cancelBookingDecisions: z.array(
      z.object({
        bookingToken: z.string(),
      }),
    ),
    keepBookingUnchangedDecisions: z.tuple([]),
  });

  const schema = z
    .object({
      bookingsDecisions: bookingsDecisionsSchema,
      bookingsDecisionsReason: z.string(),
      responsibilityAgreement: z.boolean(),
    })
    .refine(
      values => {
        if (bookingsAmount > 0) {
          return Boolean(values.bookingsDecisionsReason);
        }

        return true;
      },
      {
        message: t('validation:required'),
        path: ['bookingsDecisionsReason'],
      },
    )
    .refine(
      values => {
        if (bookingsAmount > 0) {
          return values.responsibilityAgreement;
        }

        return true;
      },
      {
        message: t('validation:required'),
        path: ['responsibilityAgreement'],
      },
    )
    .refine(
      values => {
        const movedBookingsAmount =
          values.bookingsDecisions.moveBookingDecisions.length;
        const canceledBookingsAmount =
          values.bookingsDecisions.cancelBookingDecisions.length;
        const keptBookingsAmount =
          values.bookingsDecisions.keepBookingUnchangedDecisions.length;

        return (
          movedBookingsAmount + canceledBookingsAmount + keptBookingsAmount ===
          bookingsAmount
        );
      },
      {
        message: t('spaces:common.deleteSpaceDialog.selectAllActionsError'),
        path: ['bookingsDecisions'],
      },
    );

  return schema;
};
